import IconButton from '@mui/material/IconButton';
import React from 'react';
import { CgSpinner } from 'react-icons/cg';
import { FaRegFile } from 'react-icons/fa';
import { toast } from 'react-toastify';

import LightTooltip from '@/components/atoms/LightTooltip';
import { downloadFile } from '@/utils/downloadFile';

export const TrainingControlTemplateButton = () => {
	const [loading, setLoading] = React.useState(false);

	async function download() {
		setLoading(true);
		try {
			downloadFile(
				'/extraction/training-control-template',
				'Controle de Treinamentos.xlsx',
			);
		} catch (e) {
			toast.error('Não foi possível fazer o download do template', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="cursor-pointer">
			<LightTooltip title="Baixar template para atualização de treinamentos em massa">
				<IconButton onClick={download} disabled={loading}>
					{loading ? (
						<CgSpinner
							size={30}
							color="#c1c1c1"
							className="h-full animate-spin"
						/>
					) : (
						<FaRegFile color="grey" fontSize={'1.5rem'} />
					)}
				</IconButton>
			</LightTooltip>
		</div>
	);
};
